(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[914],{

/***/ 65872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/returns",
      function () {
        return __webpack_require__(3641);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20769);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87150);




var NotFoundPage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Page__WEBPACK_IMPORTED_MODULE_3__/* .Page */ .T, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_2__/* .NoSearchResults */ .qx, {
            message: message
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 3641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53625);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15550);
/* harmony import */ var ui_pages_ReturnsPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75557);




var Returns = function() {
    var returnsPageDisabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_1__/* .useFeature */ .S)("RETURNS_PAGE_DISABLED");
    if (returnsPageDisabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_2__["default"], {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_ReturnsPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
};
/* harmony default export */ __webpack_exports__["default"] = (Returns);


/***/ }),

/***/ 62250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ OrderLookUp; },
  "r": function() { return /* binding */ getOrderSearchQuery; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./gql/queries/order.ts + 1 modules
var order = __webpack_require__(15350);
// EXTERNAL MODULE: ./utils/getSalesforceId.ts
var getSalesforceId = __webpack_require__(95271);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
;// CONCATENATED MODULE: ./utils/orders.ts

var formatPostalCode = function(postalCode, country) {
    switch(country === null || country === void 0 ? void 0 : country.toUpperCase()){
        // Combining US and CA since PNA allows these across both sites. The combined
        // formatting should work for both as there are no dashes in the CA postal codes
        case constants/* SUPPORTED_COUNTRY.US */.bM.US:
        case constants/* SUPPORTED_COUNTRY.CA */.bM.CA:
            var ref;
            return (ref = postalCode === null || postalCode === void 0 ? void 0 : postalCode.split("-")[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase();
        default:
            return postalCode;
    }
};
var formatOrderLookupField = function(key, value, countryCode) {
    switch(key){
        case "orderNo":
            return value === null || value === void 0 ? void 0 : value.toUpperCase();
        case "email":
            return value === null || value === void 0 ? void 0 : value.toLowerCase();
        case "postcode":
            if (countryCode) return formatPostalCode(value, countryCode);
            return value;
        default:
            return value;
    }
};

// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./ui/forms/custom/CustomForm.tsx + 20 modules
var CustomForm = __webpack_require__(80417);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
;// CONCATENATED MODULE: ./ui/forms/OrderLookUp/index.tsx


















var getOrderSearchQuery = function(orderLookUpQuery) {
    switch(orderLookUpQuery){
        case types/* OrderSearchOperationName.SearchOrderByEmailPhone */.G.SearchOrderByEmailPhone:
            return order/* SEARCH_ORDER_BY_EMAIL_PHONE_QUERY */.rV;
        case types/* OrderSearchOperationName.SearchOrderByEmail */.G.SearchOrderByEmail:
            return order/* SEARCH_ORDER_BY_EMAIL_QUERY */.B9;
        case types/* OrderSearchOperationName.SearchOrderByEmailPostcode */.G.SearchOrderByEmailPostcode:
            return order/* SEARCH_ORDER_BY_EMAIL_POSTCODE_QUERY */.wn;
        case types/* OrderSearchOperationName.SearchOrderByPhone */.G.SearchOrderByPhone:
            return order/* SEARCH_ORDER_BY_PHONE_QUERY */.Os;
        default:
            return order/* SEARCH_ORDER_BY_EMAIL_POSTCODE_QUERY */.wn;
    }
};
var OrderLookUp = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), countryCode = ref2.countryCode, language = ref2.language, env = ref2.env, localizeUrlPath = ref2.localizeUrlPath, orderLookUpQuery = ref2.orderLookUpQuery, allowGuestAccessToOrderDetails = ref2.staticFeatures.allowGuestAccessToOrderDetails, forms = ref2.forms, _validation = ref2.validation, prefix = _validation.phone.prefix;
    var _query = router.query, postal = _query.postal, email = _query.email, oid = _query.oid, mobileNumber = _query.mobileNumber;
    var ref3 = (0,react.useState)(false), shouldShowReturnsModal = ref3[0], setShouldShowReturnsModal = ref3[1];
    var ref4 = (0,react.useState)({
        email: "",
        phone: "",
        orderNo: ""
    } || {
        email: "",
        orderNo: "",
        postcode: ""
    } || {
        email: "",
        orderNo: ""
    } || {
        phone: "",
        orderNo: ""
    }), formData = ref4[0], setFormData = ref4[1];
    var orderSearchQuery = getOrderSearchQuery(orderLookUpQuery);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: orderSearchQuery,
        variables: (0,_object_spread/* default */.Z)({}, formData),
        pause: !formData.orderNo
    }), 2), orderDetails = ref5[0], lookupOrder = ref5[1];
    var displayReturnModal = (0,react.useCallback)(function() {
        setShouldShowReturnsModal(!!orderDetails.data);
    }, [
        orderDetails
    ]);
    var redirectToOrderPage = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3;
        var orderData = ((ref = orderDetails.data) === null || ref === void 0 ? void 0 : ref.searchOrderByPhone) || ((ref1 = orderDetails.data) === null || ref1 === void 0 ? void 0 : ref1.searchOrderByEmailPhone) || ((ref2 = orderDetails.data) === null || ref2 === void 0 ? void 0 : ref2.searchOrderByEmailPostcode) || ((ref3 = orderDetails.data) === null || ref3 === void 0 ? void 0 : ref3.searchOrderByEmail);
        if (orderData) {
            var paramFields = {
                email: formData.email,
                mobileNumber: formData.phone,
                postcode: formData.postcode
            };
            var params = Object.keys(paramFields).filter(function(key) {
                return paramFields[key] !== undefined;
            }).map(function(key) {
                return "".concat(key, "=").concat(encodeURIComponent(paramFields[key]));
            }).join("&");
            var baseUrl = localizeUrlPath("account/orders/".concat(formData.orderNo));
            router.push("".concat(baseUrl, "?").concat(params));
        }
    }, [
        formData,
        localizeUrlPath,
        orderDetails,
        router
    ]);
    (0,react.useEffect)(function() {
        if (allowGuestAccessToOrderDetails) {
            redirectToOrderPage();
        } else {
            displayReturnModal();
        }
    }, [
        allowGuestAccessToOrderDetails,
        redirectToOrderPage,
        displayReturnModal
    ]);
    var formatFields = function(data) {
        var orderNo = formatOrderLookupField("orderNo", data.orderNo);
        var email = formatOrderLookupField("email", data.orderEmail);
        var postcode = formatOrderLookupField("postcode", data.billingPostalCode, countryCode);
        switch(orderLookUpQuery){
            case types/* OrderSearchOperationName.SearchOrderByPhone */.G.SearchOrderByPhone:
                return {
                    orderNo: orderNo,
                    phone: data.phone
                };
            case types/* OrderSearchOperationName.SearchOrderByEmail */.G.SearchOrderByEmail:
                return {
                    orderNo: orderNo,
                    email: email
                };
            case types/* OrderSearchOperationName.SearchOrderByEmailPostcode */.G.SearchOrderByEmailPostcode:
                return {
                    orderNo: orderNo,
                    email: email,
                    postcode: postcode
                };
            case types/* OrderSearchOperationName.SearchOrderByEmailPhone */.G.SearchOrderByEmailPhone:
                return {
                    orderNo: orderNo,
                    email: email,
                    phone: data.phone
                };
            default:
                // PNA order search as the default
                return {
                    orderNo: orderNo,
                    email: email,
                    postcode: postcode
                };
        }
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var fields, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                fields = formatFields(data);
                setFormData(fields);
                _tmp = {};
                lookupOrder((_tmp.requestPolicy = "network-only", _tmp));
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            orderNo: oid,
            postalCode: postal,
            orderEmail: email,
            phone: mobileNumber !== null && mobileNumber !== void 0 ? mobileNumber : prefix
        },
        mode: "onChange"
    });
    var site = (0,getSalesforceId/* getSalesforceId */.j)(constants/* SUPPORTED_COUNTRY */.bM[countryCode.toUpperCase()]);
    var postcode = formatOrderLookupField("postcode", (ref = formData) === null || ref === void 0 ? void 0 : ref.postcode, countryCode);
    var formEmail = (ref1 = formData) === null || ref1 === void 0 ? void 0 : ref1.email;
    var encodedEmail = encodeURIComponent(formEmail).replace(/\./g, "%2e"); // encode email and replace all periods with the ASCII equivalent
    var encodedPostcode = encodeURI(postcode !== null && postcode !== void 0 ? postcode : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomForm/* CustomForm */.y, {
                form: form,
                onSubmit: onSubmit,
                result: orderDetails,
                config: forms.orderLookUpReturns
            }),
            !allowGuestAccessToOrderDetails && shouldShowReturnsModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                variant: "dark",
                className: "w-full max-w-screen-lg h-screen max-h-[60vh]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                        className: "absolute right-0 top-0 p-3",
                        onClick: function() {
                            return setShouldShowReturnsModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        className: "w-full h-full",
                        src: "".concat(env.returnUrl, "/Sites-").concat(site, "-Site/").concat(language, "_").concat(countryCode.toUpperCase(), "/ReturnCenter-NewReturn?oid=").concat(formData.orderNo, "&email=").concat(encodedEmail, "&postal=").concat(encodedPostcode, "&iframe")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 22498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ OrderSearchOperationName; }
/* harmony export */ });
var OrderSearchOperationName;
(function(OrderSearchOperationName) {
    OrderSearchOperationName["SearchOrderByEmail"] = "SearchOrderByEmail";
    OrderSearchOperationName["SearchOrderByEmailPhone"] = "SearchOrderByEmailPhone";
    OrderSearchOperationName["SearchOrderByEmailPostcode"] = "SearchOrderByEmailPostcode";
    OrderSearchOperationName["SearchOrderByPhone"] = "SearchOrderByPhone";
})(OrderSearchOperationName || (OrderSearchOperationName = {}));


/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87150);
/* harmony import */ var ui_components_PageHead__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9294);
/* harmony import */ var ui_forms_OrderLookUp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62250);







var ReturnsPage = function() {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Page__WEBPACK_IMPORTED_MODULE_4__/* .Page */ .T, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PageHead__WEBPACK_IMPORTED_MODULE_5__/* .PageHead */ .y, {
                title: t("pageTitle", {
                    title: t("checkOrder")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W20, {
                size: "lg",
                dataTestId: "returns-form",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                        asChild: true,
                        size: {
                            _: "xl",
                            md: "3xl"
                        },
                        weight: "bold",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: t("returnsFormHeader")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W20, {
                        size: "sm",
                        className: "pt-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kqy, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kqy, {
                                    gapY: "sm",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                            asChild: true,
                                            weight: "bold",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                children: t("returnsFormTitle")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: t("returnsFormSubtitle")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_forms_OrderLookUp__WEBPACK_IMPORTED_MODULE_6__/* .OrderLookUp */ .m, {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReturnsPage);


/***/ }),

/***/ 95271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getSalesforceId; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

// This method is similar to salesforceId env in the graphql api
// This purpose is to return salesforceId
var getSalesforceId = function(countryCode) {
    if (countryCode === _constants__WEBPACK_IMPORTED_MODULE_0__/* .SUPPORTED_COUNTRY.US */ .bM.US) {
        return "NA";
    }
    return countryCode;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1489,9294,2042,6740,769,9774,2888,179], function() { return __webpack_exec__(65872); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);